import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { CommonService } from '../../../Common/common.service';
import * as moment from 'moment';

@Injectable({ providedIn: 'root' })
export class NotificationsService
{
  admin_id: number = 0;
  user_id: number = 0;
  activity_list: any = [];
  unread_notification_count = 0;
  onActivityCountChanged: BehaviorSubject<any>;
  onActivityChanged: BehaviorSubject<any>;
  onPlanChanged: BehaviorSubject<any>;
  /**
   * Constructor
   *
   * @param {HttpClient} _httpClient
   */
  constructor(
    private _httpClient: HttpClient,
    private _commonService: CommonService,
  ) {
    this.onActivityChanged = new BehaviorSubject([]);
    this.onActivityCountChanged = new BehaviorSubject(0);
    this.onPlanChanged = new BehaviorSubject(0);
  }

  /**
   * Resolver
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

    return new Promise<void>((resolve, reject) => {

      Promise.all([

      ]).then(
        () => {
          resolve();
        },
        reject
      );
    });
  }

  getNotificationList(hideLoader): Promise<any> {
    var currentDate = moment();
    var data = {
      admin_id: this._commonService.admin_id,
      client_id: this._commonService.client_id,
      client_access_id: this._commonService.client_access_id,
      post_site_ids: this._commonService.locations_assigned,
      page_size: 30,
      offset_value: 0,
      date_format: this._commonService.date_format,
      time_format: this._commonService.time_format,
     // end_date: currentDate.add(1, "days").format('YYYY-MM-DD H:mm:ss'),
      // start_date: currentDate.subtract(6, "days").format('YYYY-MM-DD H:mm:ss')
      end_date: this._commonService.DefaultEndDate.format('YYYY-MM-DD H:mm:ss'),
      start_date: this._commonService.DefaultOneYearStartDate.format('YYYY-MM-DD H:mm:ss')
    }

    const params = new HttpParams().set('Hide-Loader', hideLoader);

    return new Promise((resolve, reject) => {
      this._httpClient.post<any>('api/dashboard/getnotificationlist', data, { params })
        .subscribe((response: any) => {
          this.activity_list = response;
          this.onActivityChanged.next(this.activity_list);
          resolve(response);
        }, reject);

    });

  }

  getNotificationUnreadCount(hideLoader): Promise<any> {
    var data = {
      admin_id: this._commonService.admin_id,
      client_id: this._commonService.client_id,
      client_access_id: this._commonService.client_access_id,
      post_site_ids: this._commonService.locations_assigned
    }

    const params = new HttpParams().set('Hide-Loader', hideLoader);

    return new Promise((resolve, reject) => {
      this._httpClient.post<any>('api/dashboard/getnotificationunreadcount', data, { params })
        .subscribe((response: any) => {
          this.unread_notification_count = response;
          this.onActivityCountChanged.next(this.unread_notification_count);
          resolve(response);
        }, reject);

    });

  }
}


